// extracted by mini-css-extract-plugin
export default {"nameItem":"NoteItem_nameItem__TNUW-","cutEdges":"NoteItem_cutEdges__g7Y-f","buttonAction":"NoteItem_buttonAction__QvyBw"};